// ** Third Party Components
import styled, { css } from "styled-components";

// #####################################################

export const StyledWrapper = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	min-height: 100px;
	overflow-y: auto;
	/* MARCIN_P: DZ-1928 - "flex: 1" zamieniłem na 3 właściwości bo scroll w kontenerze się psuł i rozpychało stronę. */
	flex-grow: 1;
	flex-shrink: 1;
	flex-basis: 0;

	& > :first-child {
		margin-top: auto;
	}

	${({ isVerticalScroll }) =>
		isVerticalScroll &&
		css`
			padding-right: 0.5rem;
		`}
`;

// #####################################################
